// @ts-ignore

import { IntlProvider } from 'react-intl';

import { SitesContextProvider } from '@/components/sites-provider';
import { UserContextProvider } from '@/components/user-context/user-context-provider';
import {
	BxpWebStargateClientProvider,
	getStargateBaseUrl,
} from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client';
import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import { GlobalNav } from '@/patterns/global-nav/src/nav-global';
import { LocationProvider } from '@/utils/location-provider';

import { MainSection } from './sections/main';

export const FourOhFourPageTemplate = () => {
	return (
		<IntlProvider locale="en" messages={{}} defaultLocale="en">
			<BxpWebStargateClientProvider baseUrl={getStargateBaseUrl()}>
				<SitesContextProvider>
					<UserContextProvider>
						<div data-testid="404-page">
							<LocationProvider
								location={
									typeof window !== 'undefined'
										? window.location
										: ({
												pathname: '/',
												href: '/',
											} as Location)
								}
							>
								<div>
									<GlobalNav
										isShowTryNowLink={true}
										tryNowLinkCtaButtonColor="light_grey"
										productKey="404"
									/>
								</div>
								<div>
									<div>
										<MainSection />
									</div>
								</div>
								<GlobalFooter />
							</LocationProvider>
						</div>
					</UserContextProvider>
				</SitesContextProvider>
			</BxpWebStargateClientProvider>
		</IntlProvider>
	);
};
